import React, {CSSProperties} from 'react';
import * as Outlines from '@heroicons/react/outline'
import * as Solids from '@heroicons/react/solid'
import {toPascalCase} from "services/string";
import {Icon as IconLike} from 'types/Icon';
import * as Custom from "./custom";
import * as Social from './social';
import IconName from "types/IconName";

// Types ----

type IconProps = {
    name: IconName | string
    className?: string
    color?: CSSProperties['color']
    outline?: boolean
}

// Helpers ----

const nameExceptions: Record<string, string> = {
    'QrCodeIcon': 'QrcodeIcon'
}

// Component ----

function Icon({name, className, color, outline = true}: IconProps) {
    const icons: Record<string, IconLike> = {
        ...(outline? Outlines : Solids),
        ...Custom,
        ...Social,
    }

    let iconName = `${toPascalCase(name)}Icon`
    iconName = nameExceptions[iconName] || iconName

    const Element = icons[iconName]

    if(!Element) {
        console.warn(`[Icon] '${name}' icon is missing`);
        return null;
    }

    return (
        <Element className={className} style={{color}} aria-hidden="true" />
    );
}

// Export ----

export default Icon;